import { createHttpResourceLocation } from '../../data-access/types/http.location';
import { Repository } from '../abstraction';
import { ReadonlyHttpRepository } from './readonly-http.repository';
import { HttpDataAccess } from '../../data-access/http.data-access';
import { Dictionary } from '../../types/dictionary';

export abstract class HttpRepository<T, TResult, TLoadParams = undefined, TCrudParams = undefined> extends ReadonlyHttpRepository<TResult, TLoadParams> implements Repository<T, TResult, TLoadParams, TCrudParams> {

  protected constructor(dataAccess: HttpDataAccess,
                        url: string) {
    super(dataAccess, url);
  }

  create(value: T, params: TCrudParams): Promise<TResult> {
    const location = createHttpResourceLocation({
      url: this.url,
      pathParams: this.getCRUDPathParams(params)
    });
    return this.dataAccess.create(location, value);
  }
  update(value: T, params: TCrudParams): Promise<TResult> {
    const location = createHttpResourceLocation({
      url: this.url,
      pathParams: this.getCRUDPathParams(params)
    });
    return this.dataAccess.update(location, value);
  }
  patch(patch: Partial<T>, params: TCrudParams): Promise<TResult> {
    const location = createHttpResourceLocation({
      url: this.url,
      pathParams: this.getCRUDPathParams(params)
    });
    return this.dataAccess.patch(location, patch);
  }
  delete(params: TCrudParams): Promise<TResult> {
    const location = createHttpResourceLocation({
      url: this.url,
      pathParams: this.getCRUDPathParams(params)
    });
    return this.dataAccess.delete(location);
  }

  protected abstract getCRUDPathParams(params: TCrudParams): Dictionary<unknown> | undefined;
}
